import axiosInstance from "./axios";

export class AsistenciaPresencialService {
  /**
   * Obtiene la lista de asistencias presenciales.
   * @returns {Promise<Object>} Respuesta de la API
   */
  getAsistenciaPresencial() {
    return axiosInstance
      .get(`/asistenciapresencial`)
      .then((res) => res.data)
  }

  /**
   * Agrega una nueva asistencia presencial.
   * @param {Object} dto Datos de la asistencia a agregar
   * @returns {Promise<Object>} Respuesta de la API
   */
  addAsistenciaPresencial(dto) {
    return axiosInstance
      .post(`/asistenciapresencial/addasistencia`, dto)
      .then((res) => res.data)
  }

  /**
   * Actualiza una asistencia presencial existente.
   * @param {Object} dto Datos de la asistencia a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  updateAsistenciaPresencial(dto) {
    return axiosInstance
      .put(`/asistenciapresencial/${dto._id}`, dto)
      .then((res) => res.data)
  }

  /**
   * Agrega una nueva asistencia de un alumno.
   * @param {Object} dto Datos del alumno
   * @returns {Promise<Object>} Respuesta de la API
   */
  addAlumnoAsistencia(dto) {
    return axiosInstance
      .post(`/asistenciapresencial`, dto)
      .then((res) => res.data)
  }

  /**
   * Obtiene el reporte de asistencias presenciales.
   * @param {Object} dto Filtros para el reporte
   * @returns {Promise<Object>} Respuesta de la API
   */
  getReporte(dto) {
    return axiosInstance
      .get(`/asistenciapresencial/report`, { params: dto })
      .then((res) => res.data)
  }

  /**
   * Obtiene las matrículas por alumno.
   * @param {Object} id Identificador del alumno
   * @returns {Promise<Object>} Respuesta de la API
   */
  getMatriculasPorAlumno(id) {
    return axiosInstance
      .get(`/matricula/matriculasporalumno`, { params: id })
      .then((res) => res.data)
  }

  /**
   * Importa asistencias desde Excel.
   * @param {string} ciclo ID del ciclo
   * @param {string} tipoasistencia Tipo de asistencia
   * @param {string} fecha Fecha en formato ISO
   * @param {Object} obj Datos del archivo
   * @returns {Promise<Object>} Respuesta de la API
   */
  uploadExcel(ciclo, tipoasistencia, fecha, obj) {
    return axiosInstance
      .post(`/asistenciapresencial/importasistencia/${ciclo}/${tipoasistencia}/${fecha}`, obj)
      .then((res) => res.data)
  }
}
